import { Icon } from '../Icon.js'
import { Spinner } from '../ui.js'

/** Said above anything the Assistant wrote, until it is undone or sent. */
export function DraftedBanner({
  writing,
  drafted,
  onUndo,
  onRedo,
}: {
  writing: boolean
  drafted: boolean
  onUndo: () => void
  onRedo: () => void
}) {
  if (!writing && !drafted) return null
  return (
    <div
      role="status"
      className="flex items-center gap-2 rounded-lg bg-violet-50 px-3 py-2 text-[13px] text-violet-800 ring-1 ring-violet-200 ring-inset"
    >
      {writing ? <Spinner className="size-3.5" /> : <Icon name="sparkles" className="size-3.5 text-violet-500" />}
      <span className="min-w-0 flex-1">
        {writing ? 'The Assistant is writing…' : 'Drafted by the Assistant. Read it before you send.'}
      </span>
      {drafted && !writing ? (
        <span className="flex shrink-0 items-center gap-3 font-semibold">
          <button type="button" className="hover:text-violet-950" onClick={onUndo}>
            Undo
          </button>
          <button type="button" className="hover:text-violet-950" onClick={onRedo}>
            Redo draft
          </button>
        </span>
      ) : null}
    </div>
  )
}

/** A template field with nothing behind it, left in the words as `[quote number]`. */
export function MissingFields({ missing, onDismiss }: { missing: string[]; onDismiss: () => void }) {
  if (missing.length === 0) return null
  return (
    <div
      role="status"
      className="flex items-start gap-2 rounded-lg bg-amber-50 px-3 py-2 text-[13px] text-amber-900 ring-1 ring-amber-200 ring-inset"
    >
      <Icon name="alert" className="mt-0.5 size-3.5 shrink-0 text-amber-600" />
      <span className="min-w-0 flex-1">
        {missing.length === 1 ? 'One field had' : `${missing.length} fields had`} nothing to fill it:{' '}
        {missing.map((label) => `[${label}]`).join(', ')}. Fill {missing.length === 1 ? 'it' : 'them'} in before you send.
      </span>
      <button type="button" aria-label="Dismiss" className="shrink-0 text-amber-700 hover:text-amber-950" onClick={onDismiss}>
        <Icon name="close" className="size-3.5" />
      </button>
    </div>
  )
}
